import { FeathersModel } from './feathersModel'
import { User } from './user'
import { Message } from '../features/messaging/message'
import { AnnouncementRead } from './announcementRead'

export class Announcement extends FeathersModel implements Message {
  static serviceName = 'list-announcements'

  userId: number
  publishedByUser: User
  title: string
  content: string
  publishedAt: Date
  isRead: boolean = true
  attachmentUri: string
  announcement_reads: AnnouncementRead[]
  user?: User

  updateFromProps(props): this {
    super.updateFromProps(props)
    if (this.publishedByUser) this.userId = this.publishedByUser.id
    return this
  }

  turnSubresourcesIntoFrontendModels() {
    if (this.userId) this.publishedByUser = User.createFromProps(User, this.user)
  }
}
